'use strict';

const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');
const menuMobile = require('./../../../services/structure/menu/mobile');
const Zone = require('./../../../services/structure/zone');
const Notifier = require('./../../../services/notifier');
const Translator = require('./../../../core/translator');
const Container = require('./../../../core/container');

module.exports.onClick = function(data) {
    let content = data.params.content;

    if (content) {
        Zone.setSmallPanel('', `<p>${Translator.translate('want_delete')}</p>`);
        Zone.setFooter(Container.get('$smallPanel'), Zone.createSubmitButtons({
            onSubmitClick: function() {
                ContentManager.remove(content);

                menuMobile.close();
                Zone.hidePanels();

                SaveManager.save().done(function() {
                    Notifier.success(Translator.translate('content_deleted'));
                });
            },
            onCancelClick: function() {
                menuMobile.close();
                Zone.hidePanels();
            },
        }));
    }
};
